'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _PersonModel = require('../../person/model/PersonModel');

var _PersonModel2 = _interopRequireDefault(_PersonModel);

var _OrganisationModel = require('../../organisation/model/OrganisationModel');

var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);

var _LocationModel = require('../../location/model/LocationModel');

var _LocationModel2 = _interopRequireDefault(_LocationModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Search = function Search(element) {
  var _this = this;

  _classCallCheck(this, Search);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Zoeken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }]
  });

  var buffer = [];

  var getPeople = function getPeople() {
    return new Promise(function (resolve, reject) {
      window.PRIM.dataAccess.get('people').then(function (people) {
        people.forEach(function (person) {
          buffer.push(new _PersonModel2.default(person));
        });

        resolve();
      }, reject);
    });
  };

  var getOrganisations = function getOrganisations() {
    return new Promise(function (resolve, reject) {
      window.PRIM.dataAccess.get('organisations').then(function (organisations) {
        var promises = 0;

        organisations.forEach(function (organisation) {
          var model = new _OrganisationModel2.default(organisation);

          if (model.values.location_id) {
            promises++;
            window.PRIM.dataAccess.get('locations', model.values.location_id).then(function (location) {
              model.location = new _LocationModel2.default(location);
              buffer.push(model);

              promises--;

              if (promises === 0) {
                resolve();
              }
            }, function () {
              buffer.push(model);

              promises--;

              if (promises === 0) {
                resolve();
              }
            });
          } else {
            buffer.push(model);
          }
        });

        if (promises === 0) {
          resolve();
        }
      }, reject);
    });
  };

  /*let getLocations = () => {
    return new Promise((resolve, reject) => { {
      PRIM.dataAccess.get('locations').then( (locations) {
        let promises = 0
          locations.forEach( (location) {
          let model = new LocationModel(location)
            if (model.values.organisation_id) {
            promises++
            PRIM.dataAccess.get('organisations', model.values.organisation_id).then( (organisation) {
              model.organisation = new OrganisationModel(organisation)
              buffer.push(model)
                promises--
                if (promises === 0) {
                resolve()
              }
            }, () => {
              buffer.push(model)
                promises--
                if (promises === 0) {
                resolve()
              }
            })
          } else {
            buffer.push(model)
          }
        })
          if (promises === 0) {
          resolve()
        }
      }, reject)
    })
  }*/

  getPeople().then(function () {
    getOrganisations().then(function () {
      _this.results.setItems(buffer);
      /*getLocations().then(() {
          results.setItems(buffer)
      });*/
    });
  });

  var onclick = function onclick(item) {
    if (item instanceof _PersonModel2.default) {
      window.PRIM.navigate('/people/' + item.values.id);
      return;
    }
    if (item instanceof _OrganisationModel2.default) {
      window.PRIM.navigate('/organisations/' + item.values.id);
      return;
    }
    if (item instanceof _LocationModel2.default) {
      window.PRIM.navigate('/locations/' + item.values.id);
      return;
    }
  };

  var div = document.createElement('div');
  div.className = 'viewport';

  this.results = new _IndexControl2.default(div, { items: [], onclick: onclick });
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = Search;


//////////////////
// WEBPACK FOOTER
// ./js/modules/search/action/Search.js
// module id = 21
// module chunks = 0